/**************************************************
 * Nombre:       Formulario_Lead_Datos.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {HistoryEduOutlined, LocalOfferOutlined, MonetizationOn, SchoolOutlined} from "@mui/icons-material";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectTextoArray from "../../Modulo_formularios/Componentes/IngresoSelectTextoArray";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";

const Formulario_Lead_Intereses = ({...props}) => {
    const cData = useContext(usuarioContext)
    const [programas, setProgramas] = useState([])
    const [escuelas, setEscuelas] = useState([])
    const [etiquetas, setEtiquetas] = useState([])

    const cambiar = (e) =>{
        let programa = props.props.getValues('programa')

        let index = programas.findIndex((e) => e.nombre === programa)

        if (index >= 0) {

            let prog = programas[index]
            props.props.setValue('idPrograma', prog.id)
            props.props.setValue('valor', prog.valor)
        }
    }



    useEffect(() => {
        if (cData.programas) {
            setProgramas(cData.programas)
        }
        if (cData.escuelas) {
            setEscuelas(cData.escuelas)
        }

        if (cData.configCrm && cData.configCrm[0]) {
            setEtiquetas(cData.configCrm[0].etiquetas)
        }

    }, [cData]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={SchoolOutlined} nombre={'Escuela'} dato={'escuela'} {...props}
                                   opciones={escuelas.map((t) => t.nombre)}
                    />
                </Grid>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFuncion Icono={HistoryEduOutlined} nombre={'Programa'} dato={'programa'} {...props}
                                   opciones={programas.map((t) => t.nombre)} setDato={cambiar}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoDinero Icono={MonetizationOn} nombre={'Inversion'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Notas de interese'} dato={'notasIntereses'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectTextoArray Icono={LocalOfferOutlined} nombre={'Etiquetas'}
                                             dato={'etiquetas'} {...props}
                                             opciones={etiquetas}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lead_Intereses